/**
 * Layout tokens. Named steps of the app's 4pt rhythm — colors and type live
 * in paper-theme.ts.
 *
 * Hand-ported from `mobile/theme/tokens.ts`, which stays canonical. There is
 * no workspace and no shared package between the iOS app and this site, so
 * this is a copy rather than an import, and the two files are kept in sync by
 * hand: when a step moves in the mobile file, mirror it here (research D9).
 * Never edit `mobile/theme/` to suit the web — the iOS app's workflows must
 * stay byte-for-byte unaffected (FR-008).
 */

export const spacing = {
  xxs: 4,
  xs: 8,
  sm: 12,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 40,
  xxxl: 64,
} as const;

export const radius = {
  sm: 8,
  /** Circular ripples and pill bars — clamped to half the box size */
  full: 9999,
} as const;

export const iconSize = {
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32,
  hero: 48,
} as const;
